<script setup lang="ts">
import { ref } from 'vue'
import ContactsModal from './ContactsModal.vue'

interface TeacherContext {
  tutor_offer?: { accept_requests?: boolean; offer_id: number } | null
  online_teaching?: { accept_requests?: boolean; teacher_id: number } | null
  education?: Array<{ title: string; text: string }>
  general: { about?: string; [key: string]: unknown }
  links?: Array<{ href: string; text: string; desc: string }>
  contacts?: {
    email?: string
    phone?: string
    whatsapp?: string
    telegram?: string
    instagram?: string
  }
  [key: string]: unknown
}

defineProps<{
  context: TeacherContext
  isCurrentUser: boolean
}>()

const contactsModal = ref(false)
</script>

<template>
  <div class="teacher-bio__tab teacher-bio__tab_general">
    <div v-if="!isCurrentUser" class="flex-adaptive teacher-bio__general-btns">
      <v-button
        v-if="context.tutor_offer && context.tutor_offer.accept_requests"
        mode="flat primary large"
        :href="`/tutors/create_request/${context.tutor_offer.offer_id}`"
        target="_blank"
      >
        Записаться на метод. консультацию
      </v-button>
      <div class="ma-1"></div>
      <v-button
        v-if="context.online_teaching && context.online_teaching.accept_requests"
        mode="flat primary large"
        :href="`/online_teaching/trial_lesson_request/${context.online_teaching.teacher_id}`"
        target="_blank"
      >
        Записать ученика на обучение
      </v-button>
    </div>

    <h2 class="teacher-bio__info-title">Образование</h2>
    <div class="d-flex flex-column teacher-bio__education">
      <template v-for="(edu, i) in context.education" :key="i">
        <h3 class="text-body-bold" v-text="edu.title"></h3>
        <p class="mt-1 mb-2" v-text="edu.text"></p>
      </template>
    </div>

    <h2 class="teacher-bio__info-title">О себе</h2>
    <div>
      <p class="teacher-bio__about" v-text="context.general.about"></p>

      <template v-for="(link, i) in context.links" :key="i">
        <v-link class="mt-2" :href="link.href" mode="primary">
          {{ link.text }}
        </v-link>
        <p v-text="link.desc"></p>
      </template>

      <v-button mode="primary outlined large" class="mt-3" @click="contactsModal = true"> Контакты </v-button>

      <ContactsModal v-model="contactsModal" :contacts="context.contacts ?? {}" />
    </div>
  </div>
</template>
